export default __webpack_public_path__ + "static/media/img_blanketBunny_grey_p.dd0ffbc1.jpg";